import { createAction } from '@reduxjs/toolkit';

export const FETCH_ANALYTIC_DOMAIN_USAGE_HISTORY = 'FETCH_ANALYTIC_DOMAIN_USAGE_HISTORY';
export const fetchAnalyticDomainUsageHistoryAction = createAction(FETCH_ANALYTIC_DOMAIN_USAGE_HISTORY);